import {
	ADD_CUSTOM_TAGS,
	UPDATE_CUSTOM_TAGS,
	DOCUMENT_RELOAD_COMMENTS_REQUEST,
	DOCUMENT_COUNT_COMMENTS_SUCCESS,
	SET_PRIORITY_ACTION,
	SET_PRIORITY_CUSTOM_TAG,
	DELETE_TAG,
	SET_DOCUMENT_DATE,
	DOWNLOAD_DOCUMENT_FAQ,
	DOWNLOAD_DOCUMENT,
	DOWNLOAD_DOCUMENTS_OF_CONCEPT,
	ADD_COMMENT,
	DELETE_COMMENT,
	DOWNLOAD_ZIP,
	UPDATE_FILE_LIST_COMMENT,
	UPDATE_FILE_LIST_TAG,
	UPDATE_META_DATA_COMMENT_COUNT,
	UPDATE_FILE_TAG,
	UPDATE_FILE_TAG_SUCCESS,
	UPDATE_FILE_TAG_FAILED,
	UPDATE_FILE_TAG_RESET,
	DOWNLOAD_SINGLE_FILE,
	DOWNLOAD_MULTIPLE_FILE,
	GET_COMMENTS,
	DELETE_SINGLE_FILE,
} from "../types"

export const addTag = (name, color_id, id) => ({
	type: ADD_CUSTOM_TAGS,
	payload: {
		name: name,
		color_id: color_id,
		id: id,
	},
})

export const updateTag = (name, color_id, id) => ({
	type: UPDATE_CUSTOM_TAGS,
	payload: {
		name: name,
		color_id: color_id,
		id: id,
	},
})

export const updateCommentRequest = (value) => ({
	type: DOCUMENT_RELOAD_COMMENTS_REQUEST,
	payload: value,
})

export const storeCommentCountRequest = (doc, countValue) => ({
	type: DOCUMENT_COUNT_COMMENTS_SUCCESS,
	payload: { id: doc, count: countValue },
})

export const setPriorityAction = (document_id, priority) => ({
	type: SET_PRIORITY_ACTION,
	payload: {
		document_id: document_id,
		priority: priority,
	},
})

export const setPriorityCustomTagAction = (priority, color, idTag, fileData = {}) => ({
	type: SET_PRIORITY_CUSTOM_TAG,
	payload: {
		priority: priority,
		color: color,
		idTag: idTag,
		fileData: fileData,
	},
})

export const deleteTagAction = (idTag) => ({
	type: DELETE_TAG,
	payload: {
		idTag: idTag,
	},
})

export const setDocumentDateAction = (document_id, newdate) => ({
	type: SET_DOCUMENT_DATE,
	payload: {
		document_id: document_id,
		newdate: newdate,
	},
})

export const downloadDocumentFAQ = () => ({
	type: DOWNLOAD_DOCUMENT_FAQ,
})

export const downloadDocumentAction = (document_id, title, source = "") => ({
	type: DOWNLOAD_DOCUMENT,
	payload: {
		document_id: document_id,
		title: title,
		source: source,
	},
})

export const downloadDocumentsOfConceptAction = (ext_id, description) => ({
	type: DOWNLOAD_DOCUMENTS_OF_CONCEPT,
	payload: {
		ext_id: ext_id,
		description: description,
	},
})

export const getComments = (document_id) => ({
	type: GET_COMMENTS,
	payload: {
		document_id: document_id,
	},
})

export const addComment = (document_id, comment, comment_id = null) => ({
	type: ADD_COMMENT,
	payload: {
		document_id: document_id,
		comment: comment,
		comment_id: comment_id,
	},
})

export const deleteComment = (comment_id, document_id) => ({
	type: DELETE_COMMENT,
	payload: {
		comment_id: comment_id,
		document_id: document_id,
	},
})

export const downloadZipAction = (documents_id, source = "") => ({
	type: DOWNLOAD_ZIP,
	payload: {
		documents_id: documents_id,
		source: source,
	},
})

export const updateFileListComment = (data) => ({
	type: UPDATE_FILE_LIST_COMMENT,
	payload: data,
})

export const updateFileListTag = (data) => ({
	type: UPDATE_FILE_LIST_TAG,
	payload: data,
})

export const updateMetadataCommentCount = (data) => ({
	type: UPDATE_META_DATA_COMMENT_COUNT,
	payload: data,
})
// update file tag actions
export const updateFileTag = (data) => ({
	type: UPDATE_FILE_TAG,
	payload: data,
})

export const updateFileTagSuccess = (data) => ({
	type: UPDATE_FILE_TAG_SUCCESS,
	payload: data,
})

export const updateFileTagFail = (data) => ({
	type: UPDATE_FILE_TAG_FAILED,
	payload: data,
})

export const updateFileTagReset = (data) => ({
	type: UPDATE_FILE_TAG_RESET,
	payload: data,
})

export const downloadSingleFileAction = (document_id, title, source = "", isAnnotation) => ({
	type: DOWNLOAD_SINGLE_FILE,
	payload: {
		document_id: document_id,
		title: title,
		source: source,
		isAnnotation: isAnnotation,
	},
})

export const downloadMultipleFileAction = (documents_id, source = "") => ({
	type: DOWNLOAD_MULTIPLE_FILE,
	payload: {
		documents_id: documents_id,
		source: source,
	},
})

export const deleteSingleFileAction = (document_id, title, source = "", isAnnotation) => ({
	type: DELETE_SINGLE_FILE,
	payload: {
		document_id: document_id,
		title: title,
		source: source,
		isAnnotation: isAnnotation,
	},
})

export const documentsActions = {
	setPriorityAction,
	downloadDocumentAction,
	setDocumentDateAction,
	downloadDocumentFAQ,
	addComment,
	downloadZipAction,
	setPriorityCustomTagAction,
	deleteTagAction,
	updateCommentRequest,
	storeCommentCountRequest,
	deleteComment,
	updateMetadataCommentCount,
	updateFileListComment,
	updateFileListTag,
	updateFileTag,
	updateFileTagFail,
	updateFileTagSuccess,
	updateFileTagReset,
	downloadSingleFileAction,
	downloadMultipleFileAction,
	deleteSingleFileAction,
}
